<template>
	<div class="infoXiug">
		<dialogBox :dialogFlag="gsFlag" @qrsFn="subFn" @callFn="gbFn" title="归属学校">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" style="width: 430px" label-width="80px">
				<el-form-item label="所属省市" prop="areaId">
					<el-cascader
						clearable
						style="width: 100%"
						v-model="ruleForm.areaId"
						:options="cityJson"
						@change="changeFn"
						:props="{ value: 'value', label: 'label', children: 'children', emitPath: true, checkStrictly: true }"
					></el-cascader>
				</el-form-item>
				<el-form-item label="学校" prop="school">
					<el-select
						ref="select"
						clearable
						style="width: 100%"
						remote
						:remote-method="remoteSearchSchool"
						@visible-change="handleVisibleChange"
						v-model="ruleForm.school"
						filterable
						default-first-option
						placeholder="请选择学校"
					>
						<el-option label="-1" value="-1">
							<div class="selBox" @click.stop="">
								<div class="selBtns" @click="scFlag = true" v-if="!scFlag">
									<img src="@/assets/img/cj.svg" alt="" class="icon" />
									创建
								</div>
								<div class="selInput" v-if="scFlag">
									<input class="inputs" placeholder="请输入内容" v-model="scVal" />
									<div @click="scQrBtn">确认</div>
									<div class="btnqx" @click="scQxBtn">取消</div>
								</div>
							</div>
						</el-option>
						<el-option v-for="item in schoolOptions" :key="item.id" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</dialogBox>

		<div class="infoXiugItem">
			<p>账户</p>
			<div class="infoXiugInput">
				{{ infoData.phonenumber }}
			</div>
		</div>
		<div class="infoXiugItem">
			<p>姓名</p>
			<div class="infoXiugInput">
				{{ infoData.nickName }}
			</div>
		</div>
		<div class="infoXiugItem">
			<p>证书编号</p>
			<div class="infoXiugInput">
				{{ infoData.certificateNumber }}
			</div>
		</div>
		<div class="infoXiugItem">
			<p>证书照片</p>
			<div class="infoXiugImg">
				<img :src="$imgUrl + infoData.certificateUrl" alt="" />
			</div>
		</div>
		<div class="infoXiugItem infoXiugItemName" @click="gsFlag = true">
			<p>归属学校</p>
			<div class="infoXiugInput">{{ infoData.school }} 【{{ infoData.address }}】</div>
		</div>
		<div class="infoXiugItem" @click="tcBtn">
			<div class="infoXiugBtn">退出登录</div>
		</div>
	</div>
</template>

<script>
import dialogBox from '@/components/pubComponents/dialogBox';
import { mapState } from 'vuex';

export default {
	name: 'grXinx',
	data() {
		return {
			cityJson: [],
			ruleForm: {
				school: '',
				areaId: ''
			},
			rules: {
				school: [{ required: true, message: '请选择学校', trigger: 'change' }],
				areaId: [{ required: true, message: '请选择省市', trigger: 'change' }]
			},
			scFlag: false,
			scVal: '',
			schoolOptions: [],
			gsFlag: false
		};
	},
	computed: {
		...mapState(['infoData'])
	},
	components: {
		dialogBox
	},
	methods: {
		changeFn(e) {
			console.log(e, 9999);
			this.$http
				.post('api/app/yydSchool/list', {
					areaList: e
				})
				.then((res) => {
					console.log(res);
					this.ruleForm.school = '';
					this.schoolOptions = res.rows;
				});
		},
		// 远程搜索学校
		remoteSearchSchool(query) {
			if (!query) {
				this.schoolOptions = [];
				return;
			}
			// 调用搜索接口
			this.$http
				.post('api/app/yydSchool/list', {
					name: query // 根据实际接口参数调整
				})
				.then((res) => {
					this.schoolOptions = res.rows || [];
				})
				.catch(() => {});
		},
		subFn() {
			this.$nextTick(() => {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						console.log(this.ruleForm, 777);
						let { areaId, school } = this.ruleForm;
						let set = this.$loading(this.$pre);
						this.$http
							.post('api/app/login/upDataUser', {
								school,
								areaId: areaId[areaId.length - 1]
							})
							.then((res) => {
								set.close();
								if (res.code == 200) {
									this.$message({
										message: '修改成功',
										type: 'success'
									});
									this.infoInit();
									this.$refs.ruleForm.resetFields();
									this.$nextTick(() => {
										this.gsFlag = false;
									});
								}
							});
					}
				});
			});
		},
		gbFn() {
			this.$refs.ruleForm.resetFields();
			this.$nextTick(() => {
				this.gsFlag = false;
			});
		},
		scQxBtn() {
			this.scFlag = false;
			this.scVal = '';
		},
		infoInit() {
			this.$http.get('api/app/login/getInfo').then((res) => {
				if (res.code == 200) {
					this.$store.commit('setInfoData', res.data);
				}
			});
		},
		init() {
			this.$http.get('api/maintain/area/areaCascaderList').then((res) => {
				this.cityJson = res.data;
			});
			this.$http
				.post('api/app/yydSchool/list?pageNum=1&pageSize=1000', {
					areaList: []
				})
				.then((res) => {
					console.log(res);
					this.schoolOptions = res.rows;
				});
		},
		scQrBtn() {
			if (this.scVal) {
				this.$http
					.post('api/app/yydSchool', {
						name: this.scVal,
						areaList: this.ruleForm.areaId || []
					})
					.then((res) => {
						if (res.code == 200) {
							this.ruleForm.school = this.scVal;
							this.schoolOptions.push({
								id: this.$uuid(),
								name: this.scVal
							});
							this.$refs.select.visible = false;
						}
					});
			}
		},
		handleVisibleChange(visible) {
			if (!visible) {
				// 选项菜单被关闭时的操作
				this.scFlag = false;
				this.scVal = '';
			}
		},
		tcBtn() {
			localStorage.clear();
			this.$store.commit('tabFn', 1);
			this.$router.replace({
				path: 'login'
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.infoXiug {
	flex: 1;
	margin-left: 10px;
	background: #ffffff;
	border-radius: 6px;
	padding: 22px 52px 0;
	.infoXiugBtn {
		width: 90px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #eb4f3d;
		font-size: 14px;
		color: #eb4f3d;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 72px auto 0;
		cursor: pointer;
	}
	.infoXiugItemName {
		cursor: pointer;
	}
	.infoXiugItem {
		display: flex;
		width: 610px;
		margin-bottom: 35px;
		color: #000000;
		font-size: 14px;
		p {
			margin-right: 13px;
			width: 56px;
			height: 38px;
			line-height: 38px;
		}
		img {
			width: 135px;
			height: 95px;
			border-radius: 6px;
		}
		.infoXiugInput {
			flex: 1;
			box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
			border-radius: 4px;
			border: 1px solid #d8e0f0;
			height: 38px;
			padding-left: 12px;
			display: flex;
			align-items: center;
		}
	}
}
.selBox {
	width: calc(100% + 40px);
	position: relative;
	left: -20px;
	box-sizing: border-box;
	color: #1d7b3a;
	.selBtns {
		position: relative;
		left: 20px;
	}
	.icon {
		width: 10px;
		height: 10px;
	}
	.selInput {
		position: relative;
		left: 20px;
		display: flex;
		.inputs {
			background: transparent;
			width: 240px;
			color: #606266;
		}
		div {
			margin-right: 4px;
			position: relative;
			right: -12px;
			font-size: 13px;
		}
		.btnqx {
			color: #999a9c;
		}
	}
}
</style>
